export type BankAccountDialogMessages = {
  formTitle: string;

  // Labels
  recipientNameLabel: string;
  bankLabel: string;
  accountTypeLabel: string;
  agencyLabel: string;
  agencyDigitLabel: string;
  accountNumberLabel: string;
  accountNumberColumnLabel: string;
  accountDigitLabel: string;
  nicknameLabel: string;
  optionsColumnLabel: string;
  accountNameLabel: string;
  bankNameLabel: string;
  bankCodeLabel: string;

  // Account Type Labels
  accountTypeCheckingLabel: string;
  accountTypeSavingsLabel: string;
  accountTypeSalaryLabel: string;
  accountTypeBusinessLabel: string;

  // Error messages
  recipientNameError: string;
  bankError: string;
  accountTypeError: string;
  agencyError: string;
  agencyDigitError: string;
  accountNumberError: string;
  accountDigitError: string;
  nicknameError: string;
  bankCodeError: string;
  bankNameError: string;
  accountNameError: string;

  submitButtonLabel: string;
  cancelButtonLabel: string;

  // General messages
  loadingMessage: string;
  errorMessage: string;
  generalErrorMessage: string;

  // Popover messages
  updatePopover: string;
  removePopover: string;

  // Confirmation dialog messages
  deleteAccountDialogTitle: string;
  deleteAccountDialogContent: string;
  deleteAccountDialogCancel: string;
  deleteAccountDialogConfirm: string;

  // Success and error messages
  deleteBankAccountSuccess: string;
  deleteBankAccountError: string;
  createBankAccountSuccess: string;
  createBankAccountError: string;

  createTransferSuccess: string;
  createTransferError: string;

  loadingText: string;
  noOptionsItems: string;
};

export const BANK_ACCOUNT_DIALOG_MESSAGES: BankAccountDialogMessages = {
  formTitle: "Cadastro de Conta Bancária",

  // Labels
  recipientNameLabel: "Nome do titular",
  bankLabel: "Banco",
  accountTypeLabel: "Tipo de conta ",
  agencyLabel: "Agência",
  agencyDigitLabel: "Dígito da agência",
  accountNumberLabel: "Conta com DV",
  accountNumberColumnLabel: "Conta - DV",
  accountDigitLabel: "Dígito da conta",
  nicknameLabel: "Apelido",
  optionsColumnLabel: "Opções",
  accountNameLabel: "Nome da conta",
  bankNameLabel: "Nome do banco",
  bankCodeLabel: "Código",

  // Account Type Labels
  accountTypeCheckingLabel: "Conta Corrente",
  accountTypeSavingsLabel: "Conta Poupança",
  accountTypeSalaryLabel: "Conta Salário",
  accountTypeBusinessLabel: "Conta Empresarial",

  // Error messages
  recipientNameError: "O nome do titular é obrigatório.",
  bankError: "O banco é obrigatório.",
  accountTypeError: "O tipo de conta é obrigatório.",
  agencyError: "O número da agência é obrigatório.",
  agencyDigitError: "O dígito da agência é inválido.",
  accountNumberError: "O número da conta é obrigatório.",
  accountDigitError: "O dígito da conta é inválido.",
  nicknameError: "O apelido deve ter no máximo 20 caracteres.",
  bankCodeError: "O código do banco é obrigatório.",
  bankNameError: "O Banco é obrigatório.",
  accountNameError: "O nome da conta é obrigatório.",

  submitButtonLabel: "Nova conta",
  cancelButtonLabel: "Cancelar",

  // General messages
  loadingMessage: "Carregando informações...",
  errorMessage: "Erro ao carregar o formulário. Tente novamente mais tarde.",
  generalErrorMessage: "Aconteceu algum erro. Tente novamente mais tarde.",

  // Popover messages
  updatePopover: "Editar",
  removePopover: "Remover",

  // Confirmation dialog messages
  deleteAccountDialogTitle: "Remover conta bancária",
  deleteAccountDialogContent:
    "Você tem certeza de que deseja remover esta conta bancária? Esta ação não pode ser desfeita.",
  deleteAccountDialogCancel: "Cancelar",
  deleteAccountDialogConfirm: "Confirmar",

  createTransferSuccess: "Transferência criada com sucesso.",
  createTransferError:
    "Não foi possível concluir a transferência. Por favor, tente novamente mais tarde.",

  // Success and error messages
  deleteBankAccountSuccess: "Conta bancária removida com sucesso.",
  deleteBankAccountError: "Erro ao remover a conta bancária. Tente novamente mais tarde.",
  createBankAccountSuccess: "Conta bancária criada com sucesso.",
  createBankAccountError: "Erro ao criar a conta bancária. Tente novamente mais tarde.",

  loadingText: "Carregando",
  noOptionsItems: "Nenhum banco encontrado",
};
